import { notification } from 'antd';

import { ApiResponseErrorMessage, ContractFormValues, MediaTypeId } from 'pricing/types';
import { apiContract } from 'utilities/http/api/pricing/apiContract';
import { apiMedia } from 'utilities/http/api/pricing/apiMedia';
import { notify } from 'utilities/notifications/notify';

export const contractCreate = async (values: ContractFormValues) => {
  try {
    const respPostContract = await apiContract.postContract(values);

    if (!respPostContract.isOk) {
      let errorMessage = respPostContract.json.message;
      if (errorMessage.includes(ApiResponseErrorMessage.UnprocessableEntity)) {
        errorMessage = "Couldn't create contract";
      }
      notify.error(errorMessage);
      return null;
    }

    const respPostContractId = respPostContract.json.contract.id as number;

    const mediaUpload = {
      mediaTypeId: MediaTypeId.BreederContract,
      mediaEntityId: respPostContractId,
      mediaEntity: 'breederContract',
      viewOrder: 1,
      isDefault: 1,
      file: values.contractFile,
    };
    await apiMedia.uploadMedia(mediaUpload);

    const respGetContract = await apiContract.getContract(respPostContractId);

    notification.success({
      message: `Contract created`,
      description: `A new document has been uploaded to this contract.`,
    });

    return respGetContract.json.contract;
  } catch (e) {
    notify.error(e.message);
    return null;
  }
};
